import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';

import Select from '../../../../components/Select';
import Form from '../../../../components/Form';
import './styles.css';

const FILTER_TYPE_SELECT = 'select';
const FILTER_TYPE_DATEPICKER = 'datepicker';

class Dropdown extends Component {
  state = {
    selectedValues: this.props.initialSelectedValues,
    stringValue: this.props.initialStringValue,
  };

  _handleChange = (value) => {
    const {
      type,
    } = this.props;

    if (type === FILTER_TYPE_SELECT) {
      this.setState({
        selectedValues: value.map(v => v.value),
      });
    }

    if (type === FILTER_TYPE_DATEPICKER) {
      this.setState({
        stringValue: value,
      });
    }
  }

  _handleSubmit = () => {
    const {
      type,
    } = this.props;

    if (type === FILTER_TYPE_SELECT) {
      this.props.onFilter(this.state.selectedValues);
    }

    if (type === FILTER_TYPE_DATEPICKER) {
      this.props.onFilter(moment(this.state.stringValue).format('YYYY-MM-DD'));
    }
  }

  render() {
    const {
      options,
      noResultsText,
      placeholder,
      submitText,
      isMulti,
      type,
      dropdownLabel,
    } = this.props;

    return (
      <Form
        className="OperationalDashboard__Filter__Form"
        submitText={submitText}
        onSubmit={this._handleSubmit}
      >
        <p className="OperationalDashboard__Filter__Dropdowm__Label">{dropdownLabel}</p>
        {type === FILTER_TYPE_SELECT &&
          <Select
            options={options}
            value={this.state.selectedValues}
            onChange={this._handleChange}
            multi={isMulti}
            noResultsText={noResultsText}
            placeholder={placeholder}
          />
        }
        {type === FILTER_TYPE_DATEPICKER &&
          <DatePicker
            selected={moment(this.state.stringValue).toDate()}
            onChange={this._handleChange}
            placeholderText={placeholder}
            inline
            dateFormat="dd/MM/yyyy"
            className="OperationalDashboard__Filter__Dropdowm__DatePicker"
          />
        }
      </Form>
    );
  }
}

Dropdown.propTypes = {
  onFilter: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.object),
  initialSelectedValues: PropTypes.arrayOf(PropTypes.number),
  initialStringValue: PropTypes.string,
  submitText: PropTypes.string,
  isMulti: PropTypes.bool,
  noResultsText: PropTypes.string,
  dropdownLabel: PropTypes.string,
  placeholder: PropTypes.string,
  type: PropTypes.oneOf(['select', 'datepicker']).isRequired,
};

Dropdown.defaultProps = {
  isMulti: true,
  dropdownLabel: 'Dropdown label',
  submitText: 'Submit',
  noResultsText: 'No results found',
  placeholder: 'I am a Placeholder',
  options: [],
  initialSelectedValues: [],
  initialStringValue: '',
};

export default Dropdown;
